import classNames from "classnames/dedupe";
import PropTypes from "prop-types";
import React, { useState } from "react";

/**
 *
 * @param {object} props
 * @param {() => any} props.logout
 * @param {string} props.userName
 * @returns
 */
export const TopMenu = ({
  logout,
  userName
}) => {
  const [userMenuOpened, setUserMenuOpened] = useState(false);
  const toggleUserMenu = () => setUserMenuOpened(!userMenuOpened);
  return userName && /*#__PURE__*/React.createElement("div", {
    className: "relative text-sm px-4 h-auto"
  }, /*#__PURE__*/React.createElement("button", {
    className: "flex items-center focus:outline-none mr-3",
    onClick: toggleUserMenu
  }, /*#__PURE__*/React.createElement("span", {
    className: "hidden md:inline-block pr-2 text-white"
  }, "Hi, ", userName, " "), /*#__PURE__*/React.createElement("i", {
    className: "fas fa-chevron-down text-white"
  })), /*#__PURE__*/React.createElement("div", {
    className: classNames("bg-white rounded shadow-md absolute mt-8 mr-6 top-0 right-0 min-w-full overflow-auto z-30", {
      invisible: !userMenuOpened
    })
  }, /*#__PURE__*/React.createElement("ul", {
    className: "list-reset"
  }, /*#__PURE__*/React.createElement("li", {
    onClick: logout
  }, /*#__PURE__*/React.createElement("button", {
    className: "w-full text-left px-4 py-2 block text-gray-900 hover:bg-gray-400 no-underline hover:no-underline"
  }, "Logout")))), /*#__PURE__*/React.createElement("div", {
    className: classNames("fixed h-screen w-screen z-20 top-0 left-0 bg-grey-30", {
      invisible: !userMenuOpened
    }),
    onClick: toggleUserMenu
  }));
};
TopMenu.propTypes = {
  userName: PropTypes.string.isRequired,
  logout: PropTypes.func.isRequired
};